// Offline fallback for the UI when the API is unreachable. The real data path is
// GET /api/pools (served from DynamoDB). City-aware so each build's fallback shows
// ITS OWN catalog — an Arlington build must never fall back to DC pools.
import type { Pool } from "../shared/types";
import { CITY } from "./city";
import { SEED_POOLS } from "../shared/seed-pools";
import { ARLINGTON_SEED_POOLS } from "../shared/arlington-seed";

export const SAMPLE_POOLS: Pool[] = CITY.id === "arlington" ? ARLINGTON_SEED_POOLS : SEED_POOLS;
